import axios from "axios";

// Small helpers shared by the seller workflow pages.
export const apiUrl = (path) => `${process.env.REACT_APP_API_URL}${path}`;

export const authConfig = (extra = {}) => ({
    ...extra,
    headers: {
        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        Accept: "application/json",
        ...(extra.headers || {}),
    },
});

export const apiGet = (path, params) => axios.get(apiUrl(path), authConfig({ params }));
export const apiPost = (path, body) => axios.post(apiUrl(path), body, authConfig());
export const apiPut = (path, body) => axios.put(apiUrl(path), body, authConfig());
export const apiDelete = (path) => axios.delete(apiUrl(path), authConfig());

export const errorText = (error, fallback = "Something went wrong. Please try again.") => {
    const data = error?.response?.data;
    if (data?.errors && typeof data.errors === "object") {
        const messages = Object.values(data.errors).flat().filter(Boolean);
        if (messages.length) return messages.join("\n");
    }
    return data?.message || error?.message || fallback;
};

export const rs = (value) =>
    value === null || value === undefined || value === ""
        ? "-"
        : `Rs ${Number(value).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;

export const usd = (value) => {
    if (value === null || value === undefined || value === "") return "-";
    const number = Number(value);
    if (!Number.isFinite(number)) return "-";
    const text = Math.abs(number).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return `${number < 0 ? "−" : ""}$${text}`;
};

export const date = (value) => (value ? new Date(value).toLocaleDateString() : "-");

export const PAYOUT_STATUS_VARIANT = {
    awaiting_details: "secondary",
    awaiting_payment: "secondary",
    on_hold: "warning",
    complaint_hold: "danger",
    eligible: "primary",
    approved: "info",
    paid: "success",
    cancelled: "dark",
};

export const APPLICATION_STATUS_VARIANT = {
    draft: "secondary",
    pending: "warning",
    approved: "success",
    rejected: "danger",
    suspended: "dark",
};
